import { render, staticRenderFns } from "./KategorieFilter.vue?vue&type=template&id=0650d9a6&scoped=true&"
import script from "./KategorieFilter.vue?vue&type=script&lang=js&"
export * from "./KategorieFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650d9a6",
  null
  
)

export default component.exports